// src/components/tour/client/DashboardClientTourSteps.tsx
import { Step } from 'react-joyride';

const paso = (
  target: string,
  content: React.ReactNode,
  placement: Step['placement'] = 'top'
): Step => ({
  target,
  content: <div style={{ textAlign: 'justify' }}>{content}</div>,
  placement,
  disableBeacon: true,
});

const DashboardClientTourSteps: Step[] = [
  paso(
    'body',
    <>
      Bienvenido a tu <strong>panel de cliente</strong>. Aquí tienes un resumen
      de tus citas y de lo que has gastado.
    </>,
    'center'
  ),

  paso(
    '.tour-month-selector',
    <>
      Elige el <strong>mes</strong> que quieres consultar. Las cifras de "Tu
      mes" se actualizan con el mes elegido.
    </>,
    'bottom'
  ),

  paso(
    '.tour-valoraciones',
    <>
      Tienes citas <strong>sin valorar</strong>. Púlsalo para dejar tu opinión
      sobre el servicio.
    </>,
    'bottom'
  ),

  paso(
    '.tour-seccion-cliente-mes > button',
    <>
      El panel está dividido en <strong>secciones</strong>. Pulsa el título o
      la flecha <strong>⌄</strong> para plegarlas o desplegarlas. Se recuerda
      cómo las dejaste.
    </>,
    'bottom'
  ),

  paso(
    '.tour-metric-citasHoy',
    <>
      Cuántas <strong>citas tienes hoy</strong>. Pulsa la flecha{' '}
      <strong>↗</strong> para ver tus citas.
    </>
  ),

  paso(
    '.tour-metric-citasMes',
    <>
      <strong>Citas del mes</strong> elegido.
    </>
  ),

  paso(
    '.tour-metric-gastoTotal',
    <>
      Lo que has <strong>gastado este mes</strong> en citas completadas. La
      etiqueta muestra el total desde que usas Bookoll.
    </>
  ),

  paso(
    '.tour-metric-cancelacionesMes',
    <>
      <strong>Citas canceladas</strong> en el mes.
    </>
  ),

  paso(
    '.tour-upcoming',
    <>
      Tus <strong>próximas citas</strong>: día, hora, negocio, precio y estado.
    </>
  ),

  paso(
    '.tour-upcoming-all',
    <>
      Pulsa <strong>Ver todas mis citas</strong> para ver el listado completo.
    </>
  ),

  paso(
    '.tour-book',
    <>
      ¿Quieres otra cita? Pulsa <strong>Reservar otra cita</strong> para buscar
      negocios.
    </>
  ),
];

export const getDashboardClientTourSteps = (): Step[] =>
  DashboardClientTourSteps.filter(
    (s) =>
      s.target === 'body' ||
      (typeof s.target === 'string' && !!document.querySelector(s.target))
  );

export default DashboardClientTourSteps;
